import PropTypes from 'prop-types';
import { React, useState, useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box, Link, Drawer, Typography, IconButton, Divider, TextField, InputAdornment } from '@mui/material';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import Iconify from '../../components/Iconify';

// mock
import account from '../../_mock/account';
// hooks
import useResponsive from '../../hooks/useResponsive';
// components
import Scrollbar from '../../components/Scrollbar';
//
import AppCache from '../../services/AppCache';
import URLS from '../../services/urls.service';
import NavItemHeader from '../../components/NavItemHeader';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 258;
const DRAWER_HEGHT = 250;

const RootStyle = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('sm')]: {
        flexShrink: 0,
        width: DRAWER_WIDTH,
        height: DRAWER_HEGHT,
    },
}));

const AccountStyle = styled('div')(({ theme }) => ({
    display: 'flex',
    textDecoration: 'none',
    // padding: theme.spacing(2, 1),
    borderRadius: Number(theme.shape.borderRadius) * 1.5,
    justifyContent: 'center',
    color: 'white'
}));

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#bf360c',
    minHeight: '50px',
    height:'50px',
   // ...theme.mixins.toolbar,
}));
// ----------------------------------------------------------------------

DashboardSidebar.propTypes = {
    isOpenSidebar: PropTypes.bool,
    onCloseSidebar: PropTypes.func,
};

export default function DashboardSidebar({ isOpenSidebar, onCloseSidebar, dwidth, onOpenSidebar, handleChildItemClick, }) {
    const { pathname } = useLocation();

    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();

    
    const PreviousSmileUrl = AppCache.GetSmilePreviousURL();
   

    const isDesktop = useResponsive('up', 'md');

    const [menus, setDashboardMenus] = useState([]);

   
    const [username, setDashboardusername] = useState([]);

    const [searchTerm, setSearchTerm] = useState('');


    useEffect(() => {
        if (!isOpenSidebar) {
            onOpenSidebar();
        }


        // PreviousUrl calls
        URLS.configFileURL().then((response) => {
            if (response.status === 200) {
                const config = JSON.parse(JSON.stringify(response.data));
                // AppCache.SetCurrentAPIURL(config.SmileServiceApiBaseUrl);
                AppCache.SetSmilePreviousURL(config);
               
            }
            else {
                // Failure response
                alert("Api URL  Failed");
            }
        })
    }, [pathname]);

    useEffect(() => {
        setDashboardMenus(CurrentLoggedInUser.Menus);
        setDashboardusername(CurrentLoggedInUser.ExecutiveName);
    }, [pathname]);

    const filteredMenus = (menus || [])
        .map((menu) => {
            const name = menu?.MenuName?.toLowerCase() || '';
            const term = searchTerm.toLowerCase();

            const matchParent = name.includes(term);
            const matchChildren = (menu?.Children || []).filter(
                (child) => child?.MenuName?.toLowerCase().includes(term)
            );

            return matchParent || matchChildren.length
                ? { ...menu, Children: matchChildren.length ? matchChildren : menu.Children || [] }
                : null;
        })
        .filter(Boolean);


    const renderContent = (
        <Scrollbar
            sx={{
                height: 1,
                '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' }

            }}
        >
           
            {!isOpenSidebar && <>
                <nav sx={{ background: '#FFFFFF', alignItems: 'center' }}>
                    {(searchTerm ? filteredMenus : menus).map((item, index) => {
                        if (!item) return null; 
                        return <NavItemHeader key={`${item.MenuName}-${index}`} item={item} onOpenSidebar='false' menuUrl={item.MenuURL} handleChildItemClick={handleChildItemClick} />;
                    })}

                </nav>
                </>
            }
            {isOpenSidebar && <>
               
                <nav sx={{ background: '#FFFFFF', alignItems: 'center' }}>
                    {(searchTerm ? filteredMenus : menus).map((item, index) => {
                        if (!item) return null; 
                        return <NavItemHeader key={`${item.MenuName}-${index}`} item={item} onOpenSidebar='true' menuUrl={item.MenuURL} handleChildItemClick={handleChildItemClick} />;
                 })}      
                </nav>   
            </>
            }
            <Box sx={{ flexGrow: 1 }} />

        </Scrollbar>
    );
    console.log("menus>>>>>>>>>>>", menus, renderContent)


    return (
        <RootStyle sx={{
            width: { sm: dwidth }
        }}>
            {!isDesktop && (
                <Drawer
                    open={isOpenSidebar}
                    onClose={onCloseSidebar}
                    PaperProps={{
                        sx: {
                            width: DRAWER_WIDTH, backgroundColor: '#FFFFFF',
                            '& .MuiDrawer-paper': {
                                width: DRAWER_WIDTH, // make sure paper itself gets it
                                boxSizing: 'border-box',
                            },
                        },
                    }}
                >

                    <DrawerHeader
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            px: 2, // padding left/right
                            py: 1, // padding top/bottom
                            bgcolor: "#FFFFFF", // same background color as your screenshot
                            border: 'solid #E5E7EB', borderWidth: '0 1px 1px 0'
                        }}
                    >
                        {isOpenSidebar && (
                            <>
                                <Box component="img" src="/static/illustrations/TikeTicLOGO.png" sx={{
                                    width: 95, height: 46
                                }} />
                                <IconButton onClick={onOpenSidebar} sx={{ color: "#928A8A" }}>
                                    <Iconify icon="ri:arrow-left-double-line" />
                                </IconButton>
                            </>
                        )}

                        {!isOpenSidebar && (
                            <IconButton onClick={onCloseSidebar} sx={{ color: "#928A8A" }}>
                                <Iconify icon="ri:arrow-left-double-line" />
                            </IconButton>
                        )}
                    </DrawerHeader>
                    <TextField
                        size="small"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <ManageSearchOutlinedIcon sx={{ color: '#989898' }} />
                                </InputAdornment>
                            ),
                        }}
                        sx={{
                            my: 1,
                            mx: 2,

                        }}
                    />

                    {renderContent}
                </Drawer>
            )}

            {isDesktop && (
                <Drawer
                    open={isOpenSidebar}
                    onClose={onCloseSidebar}
                    variant="permanent"
                    PaperProps={{
                        sx: {
                            width: dwidth, borderRightStyle: 'dashed', backgroundColor: '#FFFFFF',
                        },
                    }}
                >
                    <DrawerHeader
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            px: 2, // padding left/right
                            py: 1, // padding top/bottom
                            bgcolor: "#FFFFFF", // same background color as your screenshot
                            border: 'solid #E5E7EB', borderWidth: '0 1px 1px 0'
                        }}
                    >
                        {isOpenSidebar && (
                            <>
                                <Box component="img" src="/static/illustrations/TikeTicLOGO.png" sx={{
                                    width: 95, height: 46
                                }} />
                                <IconButton onClick={onOpenSidebar} sx={{ color: "#928A8A" }}>
                                    <Iconify icon="ri:arrow-left-double-line" />
                                </IconButton>
                            </>
                        )}

                        {!isOpenSidebar && (
                            <IconButton onClick={onCloseSidebar} sx={{ color: "#928A8A" }}>
                                <Iconify icon="ri:arrow-left-double-line" />
                            </IconButton>
                        )}
                    </DrawerHeader>
                    <TextField
                        size="small"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <ManageSearchOutlinedIcon sx={{ color: '#989898' }} />
                                </InputAdornment>
                            ),
                        }}
                        sx={{
                            my: 1,
                            mx: 2,
                            
                        }}
                    />
                    {renderContent}
                </Drawer>
            )}
        </RootStyle>
    );
}
